import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Descriptions, Table, Typography, Divider, Row, Col, Space, Button } from "antd";
import axiosInstance from "../../../../configs";
import dayjs from "dayjs";

const { Title, Text } = Typography;

export default function PemuatanPrint() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentTime, setCurrentTime] = useState(dayjs());

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/pemuatan/${id}`)
                .then(res => {
                    setData(res.data);
                })
                .catch(err => {
                    console.error(err);
                })
                .finally(() => setLoading(false));
        }
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!data) return <div>Data not found</div>;

    const { header, details } = data;

    // Calculate Total Quantity
    const totalQty = details.reduce((acc, curr) => acc + (Number(curr.qty_muat) || 0), 0);
    const kemasanTotal = details[0].kemasan;
    const formattedDate = dayjs(currentTime).format("D MMMM YYYY");

    return (
        <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', maxWidth: 800, margin: '0 auto' }}>
            {/* Header / Kop using Pita Cukai Style */}
            <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img
                    src="/assets/media/logos/alb.png"
                    alt="ALB Logo"
                    style={{ width: 120, display: "block", margin: "0 auto 10px auto" }}
                />
            </div>

            <div style={{ textAlign: "center", marginBottom: 5 }}>
                <Title level={4} style={{ margin: 0, textTransform: "uppercase" }}>SURAT JALAN</Title>
            </div>

            <div style={{ textAlign: "center", marginBottom: 20 }}>
                <Text style={{ fontSize: 12 }}>Tanggal : {formattedDate}</Text>
            </div>

            {/* Recipient Info */}
            <div style={{ marginBottom: 20, fontSize: 12 }}>
                <div style={{ marginBottom: 4 }}>Perihal: Pengiriman Barang</div>
                <div style={{ marginTop: 10 }}>Kepada Yth.</div>
                <div style={{ fontWeight: "bold" }}>{header.nama_importir || header.nama_penerima || "PIHAK IMPORTIR"}</div>
                <div>JAKARTA - INDONESIA</div>
            </div>

            <div style={{ marginBottom: 10, fontSize: 12 }}>
                <Text>Bersama dengan ini kami sampaikan telah mengirimkan sejumlah barang berikut ini:</Text>
            </div>

            {/* Table */}
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #000", marginBottom: 20, fontSize: 11 }}>
                <thead>
                    <tr style={{ backgroundColor: "#fff" }}>
                        <th style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center", width: 40 }}>No.</th>
                        <th style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "left" }}>Kode Barang</th>
                        <th style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "left" }}>Nama Barang</th>
                        <th style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center", width: 80 }}>Jumlah</th>
                        <th style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "left", width: 100 }}>Satuan</th>
                    </tr>
                </thead>
                <tbody>
                    {details.map((item, index) => (
                        <tr key={index}>
                            <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>{index + 1}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 8px" }}>{item.item_code}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 8px" }}>{item.item_name || item.uraian_barang || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 8px", textAlign: "center" }}>{item.qty_muat}</td>
                            <td style={{ border: "1px solid #000", padding: "4px 8px" }}>{item.kemasan || item.unit || "-"}</td>
                        </tr>
                    ))}
                    {/* Add Total Row if needed similar to Pita Cukai */}
                    <tr>
                        <td colSpan={3} style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold", textAlign: "right" }}>Total Barang</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px", fontWeight: "bold", textAlign: "center" }}>{totalQty}</td>
                        <td style={{ border: "1px solid #000", padding: "4px 8px" }}>{kemasanTotal || "-"}</td>
                    </tr>
                </tbody>
            </table>

            {/* Footer / Signatures */}
            <div style={{ fontSize: 12, marginTop: 10 }}>
                <div style={{ marginBottom: 4 }}>Catatan: {header.nomor_pemuatan}</div>
                <div style={{ marginBottom: 4 }}>No. Polisi: {header.no_polisi || "-"}</div>

                <Row style={{ marginTop: 40 }}>
                    <Col span={12} style={{ textAlign: "left" }}>
                        <div>Yang Menyerahkan,</div>
                        <div style={{ marginTop: 60, borderBottom: "1px solid #000", maxWidth: 150 }}></div>
                        <div>( Petugas Gudang )</div>
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                        <div style={{ marginRight: 20 }}>
                            <div>Yang Menerima,</div>
                            <div style={{ marginTop: 60, borderBottom: "1px solid #000", display: "inline-block", minWidth: 150 }}></div>
                            <div style={{ marginLeft: 90, textAlign: "center", width: "100%", paddingRight: 0 }}>
                                {header.driver ? `( ${header.driver} )` : "( ........................... )"}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Print Trigger */}
            <div className="print-controls" style={{ textAlign: "center", marginTop: 40, display: "none" }}>
                {/* The button is hidden in print media via CSS usually, but here we just made a specialized page */}
            </div>
            <style>{`
                @media print {
                    .print-controls { display: none !important; }
                    @page { margin: 2cm; }
                    body {
                        -webkit-print-color-adjust: exact;
                    }
                }
            `}</style>

            <div className="print-controls" style={{ marginTop: 20, textAlign: 'center' }}>
                <Button type="primary" onClick={() => window.print()}>Print</Button>
            </div>
        </div>
    );
}
